/* eslint-disable eqeqeq */

import {
  AbsoluteCenter,
  Box,
  Button,
  Divider,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Input,
  Stack,
  Text,
  chakra,
} from "@chakra-ui/react";
import Select from "react-select";

import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { BiLowVision, BiShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import {
  getSystemGovernmentRequest,
  getSystemGradesRequest,
  getSystemMajorsRequest,
  getSystemRegionRequest,
  registerUserAction,
} from "../../../modules/auth/Actions";

const colourStyles = (isValid) => {
  return {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      padding: "5px",
      borderRadius: "10px",
      boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
      border: isValid == "Required" ? "solid 1px red" : "solid 1px #0100108",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
};

export const studentSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  mother_phone: Yup.string().required("Required"),
  grade_id: Yup.string().required("Required"),
  major_id: Yup.string().required("Required"),
  gov_id: Yup.string().required("Required"),
  region_id: Yup.string().required("Required"),
  school: Yup.string().required("Required"),
  gender: Yup.string().required("Required"),
  national_id: Yup.string().min(14),
});
export const registerSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  mother_phone: Yup.string().required("Required"),
  grade_id: Yup.string().required("Required"),
  major_id: Yup.string().required("Required"),
  gov_id: Yup.string().required("Required"),
  region_id: Yup.string().required("Required"),
  school: Yup.string().required("Required"),
  gender: Yup.string().required("Required"),
  national_id: Yup.string().min(14),
});
const RegisterForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [inputType, setInputType] = useState("password");

  const { governments, regions, grades, majors } = useSelector(
    (state) => state.auth
  );

  const formik = useFormik({
    initialValues: {},
    validationSchema: registerSchema,
    validateOnChange: true,
    onSubmit: (values) => {
      dispatch(registerUserAction(values));
    },
  });

  useEffect(() => {
    dispatch(getSystemMajorsRequest());
    dispatch(getSystemGovernmentRequest());
    dispatch(getSystemGradesRequest());
  }, []);

  useEffect(() => {
    if (formik.values.gov_id)
      dispatch(getSystemRegionRequest(formik.values.gov_id));
  }, [formik.values.gov_id]);

  const governmentList = governments?.map((val) => ({
    label: val?.name_ar,
    value: val?.id,
  }));
  const regionsList = regions?.map((val) => ({
    label: val?.name_ar,
    value: val?.id,
  }));
  const gradesList = grades?.map((val) => ({
    label: val?.name_ar,
    value: val?.id,
  }));
  const majorsList = majors?.map((val) => ({
    label: val?.name,
    value: val?.id,
  }));

  console.log(formik);

  const errorStyle = (isValid) =>
    isValid == "Required" ? "red !important" : "#0100108 !important";

  return (
    <div dir="rtl">
      <form onSubmit={formik.handleSubmit}>
        <Flex
          flexDirection="column"
          w="100%"
          gap={8}
          fontFamily="sans-serif"
          boxShadow="0 0 16px 0 rgba(0, 0, 0, 0.16)"
          p={6}
          borderRadius={16}
        >
          <Heading mb="10px" color="main_1">
            محتاجين البيانات دي للتسجيل معانا
          </Heading>
          <Stack flexDirection="row" gap={10}>
            <Box w="100%">
              <Flex alignItems={"center"}>
                <FormLabel
                  htmlFor="name"
                  className="form-label "
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  الاسم بالكامل رباعي <span style={{ color: "red" }}>*</span>
                </FormLabel>
              </Flex>

              <Input
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "1px solid",
                  backgroundColor: "#fff",
                }}
                borderColor={errorStyle(formik?.errors.name)}
                name="name"
                size="lg"
                onChange={formik.handleChange}
                value={formik.values.name}
                onBlur={formik.handleBlur}
              />
            </Box>
            <Box w="100%" mt="0 !important" position="relative">
              <Flex alignItems={"center"}>
                <FormLabel
                  htmlFor="password"
                  className="form-label"
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  كلمة المرور <span style={{ color: "red" }}>*</span>
                </FormLabel>
              </Flex>

              <Input
                style={{
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "1px solid",
                  backgroundColor: "#fff",
                  width: "100%",
                }}
                name="password"
                size="lg"
                borderColor={errorStyle(formik?.errors.password)}
                onChange={formik.handleChange}
                value={formik.values.password}
                type={inputType}
              />

              <Icon
                position={"absolute"}
                left="10px"
                top="50px"
                fontSize="25px"
                color="main_1"
                as={inputType == "password" ? BiShow : BiLowVision}
                onClick={() =>
                  inputType == "password"
                    ? setInputType("text")
                    : setInputType("password")
                }
              />
            </Box>
          </Stack>

          <Stack flexDirection="row" gap={10}>
            <Box w="100%">
              <Flex alignItems={"center"}>
                <FormLabel
                  htmlFor="email"
                  className="form-label "
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  البريد الإلكتروني
                </FormLabel>
              </Flex>

              <Input
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "1px solid",
                  backgroundColor: "#fff",
                }}
                name="email"
                borderColor={errorStyle(formik?.errors.email)}
                size="lg"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
            </Box>
            <Box w="100%">
              <Flex alignItems={"center"}>
                <FormLabel
                  htmlFor="phone"
                  className="form-label "
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  رقم الطالب <span style={{ color: "red" }}>*</span>
                </FormLabel>
              </Flex>

              <Input
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "1px solid",
                  backgroundColor: "#fff",
                }}
                name="phone"
                borderColor={errorStyle(formik?.errors.phone)}
                size="lg"
                onChange={formik.handleChange}
                value={formik.values.phone}
              />
            </Box>
          </Stack>

          <Stack flexDirection="row" gap={10}>
            <Box w="100%" mt="0 !important">
              <FormLabel fontSize="22px">
                الصف الدراسي <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <Select
                options={gradesList}
                styles={colourStyles(formik?.errors?.grade_id)}
                placeholder="المادة"
                name="grade_id"
                onChange={(val) => formik.setFieldValue("grade_id", val?.value)}
              />
            </Box>
            <Box w="100%" mt="0 !important">
              <FormLabel fontSize="22px">
                الشعبة <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <Select
                options={majorsList}
                styles={colourStyles(formik?.errors?.major_id)}
                dir="rtl"
                placeholder="الشعبة"
                name="major_id"
                onChange={(val) => formik.setFieldValue("major_id", val?.value)}
              />
            </Box>
          </Stack>

          <Stack flexDirection="row" gap={10}>
            <Box w="100%" mt="0 !important">
              <FormLabel fontSize="22px">
                المحافظة <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <Select
                options={governmentList}
                styles={colourStyles(formik?.errors?.gov_id)}
                placeholder="المحافظة"
                name="gov_id"
                onChange={(val) => formik.setFieldValue("gov_id", val?.value)}
              />
            </Box>
            <Box w="100%" mt="0 !important">
              <FormLabel fontSize="22px">
                المنطقة <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <Select
                options={regionsList}
                styles={colourStyles(formik?.errors?.region_id)}
                dir="rtl"
                placeholder="المنطقة"
                name="region_id"
                onChange={(val) =>
                  formik.setFieldValue("region_id", val?.value)
                }
              />
            </Box>
          </Stack>

          <Stack flexDirection="row" gap={10}>
            <Box w="100%">
              <Flex alignItems={"center"}>
                <FormLabel
                  htmlFor="school"
                  className="form-label "
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  المدرسة <span style={{ color: "red" }}>*</span>
                </FormLabel>
              </Flex>

              <Input
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "1px solid",
                  backgroundColor: "#fff",
                }}
                name="school"
                size="lg"
                borderColor={errorStyle(formik?.errors.school)}
                onChange={formik.handleChange}
                value={formik.values.school}
              />
            </Box>
            <Box w="100%" mt="0 !important">
              <FormLabel fontSize="22px"> النوع </FormLabel>
              <Select
                options={[
                  { value: "male", label: "ذكر" },
                  { value: "female", label: "انثي" },
                ]}
                styles={colourStyles(formik?.errors?.gender)}
                dir="rtl"
                placeholder="النوع"
                name="gender"
                onChange={(val) => formik.setFieldValue("gender", val?.value)}
              />
            </Box>
          </Stack>

          <Stack flexDirection="row" gap={10}>
            <Box w="100%">
              <Flex alignItems={"center"}>
                <FormLabel
                  htmlFor="mother_phone"
                  className="form-label "
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  رقم المتابعة{" "}
                  <span style={{ fontSize: "12px" }}> (واتس اب ماما)</span>
                  <span style={{ color: "red" }}>*</span>
                </FormLabel>
              </Flex>

              <Input
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "1px solid",
                  backgroundColor: "#fff",
                }}
                name="mother_phone"
                borderColor={errorStyle(formik?.errors.mother_phone)}
                size="lg"
                onChange={formik.handleChange}
                value={formik.values.mother_phone}
              />
            </Box>
            <Box w="100%">
              <Flex alignItems={"center"}>
                <FormLabel
                  htmlFor="father_phone"
                  className="form-label "
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  رقم المتابعة{" "}
                  <span style={{ fontSize: "12px" }}> (واتس اب بابا)</span>
                </FormLabel>
              </Flex>

              <Input
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "1px solid",
                  backgroundColor: "#fff",
                }}
                name="father_phone"
                borderColor={errorStyle(formik?.errors.father_phone)}
                size="lg"
                onChange={formik.handleChange}
                value={formik.values.father_phone}
              />
            </Box>
          </Stack>

          <Stack flexDirection="row" gap={10}>
            <Box w="48%">
              <Flex alignItems={"center"}>
                <FormLabel
                  htmlFor="national_id"
                  className="form-label "
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  الرقم القومي <span style={{ color: "red" }}>*</span>
                </FormLabel>
              </Flex>
              {console.log(formik?.errors.national_id)}
              <Input
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "1px solid",
                  backgroundColor: "#fff",
                }}
                size="lg"
                name="national_id"
                borderColor={errorStyle(formik?.errors.national_id)}
                onChange={formik.handleChange}
                value={formik.values.national_id}
              />
            </Box>
          </Stack>

          <Button
            mt="40px"
            type="submit"
            w="250px"
            p="22px"
            alignSelf={"center"}
            isLoading={isLoading}
            bg="main_1"
            color="white"
          >
            اعمل حساب جديد
          </Button>
        </Flex>
      </form>

      <Box position="relative" py="8">
        <Divider />
        <AbsoluteCenter color="black" px="4">
          أو
        </AbsoluteCenter>
      </Box>

      <Text color="black" textAlign="center" fontSize="22px">
        عندك حساب!
        <chakra.span
          color="main_1"
          fontWeight={600}
          px={2}
          cursor="pointer"
          textDecoration="underline"
          onClick={() => navigate("/login")}
        >
          تسجيل دخول
        </chakra.span>
      </Text>
    </div>
  );
};

export default RegisterForm;
